import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';
import Select from 'components/select';
import { memberForm, OrderPayload, showisExistADGrp } from 'pages/myidm/store';
import { resetCostEstimateDetails } from 'pages/myidm/utils';

export const GroupType = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [form, setForm] = useRecoilState(memberForm);
    const [, setIsExistADGrp] = useRecoilState(showisExistADGrp);
    const [options, setOptions] = React.useState([]);
    const groupTypeApi = useMutation(() => axios.get(endPoints.myIdm.groupTypes));
    const setEnv = (groupType) => {
        const shouldUpdateOrderState = order?.groupType !== groupType;
        if (shouldUpdateOrderState) {
            setOrder({
                ...order,
                groupType,
                modifyRequestType: null,
                domainType: null,
                // businessApplication: null,
                // businessAppDetails: null,
                // sector: null,
                // environment: null,
                // envShortName: null,
                appService: null,
                appShortName: null,
                adGroupType: null,
                adGroupTypeDetails: null,
                applicationName: null,
                adGroup: null,
                adGroupOwner: null,
                nonSafeDetailsGpid: [],
                members: [],
                groupOwner: null,
                groupOwnerDetails: null,
                projectName: null,
                // New - AD Group
                multipleResourceGroups: [
                    {
                        groupCategory: null,
                        groupSubCategory: null,
                        activeDirectoryGroupType: null,
                        domainType: null,
                        groupOwner: null,
                        groupName: null,
                        members: [],
                    },
                ],
                // Modify - AD Group - Membership
                multipleAdGroups: [{ adGroup: null, adGroupOwner: null, members: [] }],
                // Modify - AD Group - Removal
                adGroupMembers: [],
                estimatedCost: resetCostEstimateDetails,
            });
            setIsExistADGrp(false);
            setForm({
                ...form,
                selectedMember: null,
                member: null,
            });
        }
    };

    const resetOptions = () => {
        setOptions([]);
    };

    const isExistsInOptions = (environmentValue) => options.find((option) => environmentValue === option.value);

    const handleOnSelectChange = (selected) => setEnv(selected.value);

    React.useEffect(() => {
        if (groupTypeApi?.isSuccess) {
            // TODO: Need to remove mock data after api side implementation is done
            const mockGroupTypeForNew = [
                {
                    id: '0aea68aa-8b04-4f04-b0d0-e889474a084b',
                    groupType: 'LDAP Group',
                    displayName: 'LDAP Group',
                    isTypeToDisplay: true,
                },
                {
                    id: '8f49e9be-3919-4bce-9abf-9a687b5cee7f',
                    groupType: 'Active Directory Group',
                    displayName: 'Active Directory Group',
                    isTypeToDisplay: true,
                },
            ];

            const mockGroupTypeForModify = [
                {
                    id: '0aea68aa-8b04-4f04-b0d0-e889474a084b',
                    groupType: 'LDAP Group',
                    displayName: 'LDAP Group',
                    isTypeToDisplay: true,
                },
                {
                    id: '8f49e9be-3919-4bce-9abf-9a687b5cee7f',
                    groupType: 'Active Directory Group',
                    displayName: 'Active Directory Group',
                    isTypeToDisplay: true,
                },
            ];

            const mockGroupType = order?.typeOfRequest === 'New' ? mockGroupTypeForNew : mockGroupTypeForModify;

            setOptions(
                (mockGroupType || groupTypeApi?.data?.data)
                    ?.filter((app) => app?.isTypeToDisplay)
                    ?.map((app) => ({ label: app?.displayName, value: app?.groupType, data: app }))
            );
        }
    }, [groupTypeApi?.isSuccess, order?.typeOfRequest]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.groupType) {
            setOrder({ ...order, groupType: options?.[0].value });
        }
        if (options && options?.length && order?.groupType) {
            const groupType = isExistsInOptions(order?.groupType);
            setOrder({ ...order, groupType: groupType?.value });
        }
    }, [options]);

    React.useEffect(() => {
        resetOptions();
        groupTypeApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!order?.groupType && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.groupType, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                dataTestId="group-type-autocomplete"
                key="groupType"
                label="Group Type *"
                value={options.find((option) => option.value === order?.groupType)?.label || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={groupTypeApi.isLoading}
                isLoading={groupTypeApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(GroupType);
